/**************************************************
 * Nombre:       Registro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Divider, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {Check, Login} from '@mui/icons-material'
import Formulario_Registro from "../Formularios/Formulario_Registro";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {crearCuenta} from "../../CodNegocio/Cuentas/crearCuenta";
import {funCrearUsuario} from "../../Servicios/Auth/funCrearUsuario";

const Registro = ({clickRegistro}) => {
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Avisos, Cargador, iniciarCarga, terminar} = useCargador({logoRedondo: logo})

    const registrarse = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga()
        if (entidad.pass !== entidad.pass2) {
            terminar({aviso: 'Las contraseñas no coinciden', variante: 'error'})
        }
        let dox = await funCrearUsuario(entidad.correo, entidad.pass)
        if (dox.res) {
            let des = await crearCuenta(entidad)
            if (des.res) {
                terminar({aviso: 'Registro realizado, ingresando al sistema'})
            } else {
                terminar({aviso: 'Error al crear la cuenta', variante: 'error'})
            }

        } else {
            terminar({aviso: dox.data, variante: 'error'})
        }
    }


    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            sx={{py: 8,}}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 32, fontWeight: 800, px: 1}}>Registrase es muy facil!</Typography>
            </Grid>

            <Grid container size={12}
                  sx={{justifyContent: 'flex-start', marginTop: -2}}>
                <Typography sx={{fontSize: 16, fontWeight: 300, px: 1, lineHeight: 1.1}}>
                    Llena los siguientes datos
                </Typography>
            </Grid>

            <Grid container size={12} sx={{justifyContent: 'center', mt: 2}}>
                <Formulario_Registro props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Button
                    onClick={() => registrarse()}
                    startIcon={<Check/>}>Registrarme</Button>
            </Grid>


            <Grid container size={12} sx={{marginTop: 2}}>
                <Divider sx={{width: '100%'}}/>
            </Grid>


            <Grid container size={6} sx={{justifyContent: 'flex-start', px: 1}}>
                <Typography sx={{lineHeight: 1.1, fontWeight: 600}}>Ya tienes tu usuario?</Typography>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-end', px: 1}}>
                <Button
                    onClick={() => clickRegistro()}
                    startIcon={<Login/>}>Ir a ingreso</Button>

            </Grid>


        </Grid>
    )

}
export default Registro    